import React from 'react'

const SvgEyeHiddenFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M11.78 8a3.994 3.994 0 00-3.779 3.775L8 11.773l-3.382 3.35a23.875 23.875 0 01-1.967-1.68S2 12.926 2 11.996s.654-1.452.654-1.452C5.855 7.511 8.99 6 11.995 5.995c.547 0 1.093.048 1.632.144l-1.852 1.856.005.006V8zm4.21 4.204l.01.01 3.368-3.37a23.55 23.55 0 011.997 1.699s.63.522.63 1.452c0 .93-.608 1.43-.608 1.43-3.21 3.047-6.387 4.565-9.392 4.57a9.203 9.203 0 01-1.619-.143l1.824-1.857-.005-.005a3.994 3.994 0 003.795-3.786zm4.24-9.85c.471-.472.942-.472 1.414 0 .471.471.471.942 0 1.414L3.774 21.636c-.472.472-.944.472-1.415 0-.471-.471-.471-.943 0-1.414l17.87-17.868h.001z' />
  </svg>
)

export default SvgEyeHiddenFilled
